import { BaseQueryFn, EndpointBuilder, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Designation, ResponseList } from "types";
import apiRoutes from "../apiRoutes";

export const designationApi = (builder: EndpointBuilder<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, string, "api">) => ({
    getDesignations: builder.query<ResponseList<Designation>, void>({
        query: () => apiRoutes.getDesignations,
    }),
})